import {twMerge} from "tailwind-merge";
const Loader = ({className}) => {
  return (
    <div id="preloader" className={className + " z-50"}>
      <div className="sk-three-bounce !bg-transparent">
        <div className="sk-child sk-bounce1"></div>
        <div className="sk-child sk-bounce2"></div>
        <div className="sk-child sk-bounce3"></div>
      </div>
    </div>
  );
};
export default Loader;
